export interface GameStep {
  step: number;
  description: string;
}

export interface Game {
  id: string;
  title: string;
  description: string;
  shortDesc: string;
  image: string;
  chibiImage: string;
  tag?: string;
  players: string;
  duration: string;
  category: 'Đồng đội' | 'Cá nhân';
  rules: string[];
  howToPlay: GameStep[];
  benefits: string[];
  notes: string[];
  videoUrl?: string;
  relatedKnowledge: string;
  countdownSeconds: number;
}

export const games: Game[] = [
  {
    id: "keo-co",
    title: "Kéo co",
    shortDesc: "Trò chơi kéo co rèn luyện sức mạnh và tinh thần đoàn kết",
    description: "Kéo co là trò chơi tập thể được yêu thích trong các lễ hội Bahnar. Trong văn hóa dân gian của người Bahnar, trò chơi kéo co có hai hình thức phổ biến là kéo co dây và kéo co bằng tay, cả hai đều là những hoạt động tập thể giúp rèn luyện thể lực và tinh thần đoàn kết. Đặc biệt, hình thức kéo co dây, dụng cụ là dây tơgrăn (một loại dây làm từ vỏ cây hơdrong rừng, rất dẻo và chắc, được se thành dây thừng to bằng ngón tay cái)",
    image: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/3bb636324d9de9e8e994869301122864.png",
    chibiImage: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/6ca39e48788e865764b77575c8ab5bc4.png",
    players: "6–20 người",
    duration: "3-5 phút",
    category: "Đồng đội",
    rules: [
      "Hai đội phải có số người bằng nhau",
      "Các đội sẽ trả lời các câu hỏi trong thời gian 5 phút",
      "Đội nào được nhiều điểm hơn sẽ giành chiến thắng"
    ],
    howToPlay: [
      { step: 1, description: "Chia đều người thành 2 đội, số người mỗi đội bằng nhau" },
      { step: 2, description: "Mỗi đội cầm một đầu của sợi dây\u00a0" },
      { step: 3, description: "Vạch kẻ trung điểm sợi dây\u00a0" },
      { step: 4, description: "Khi bắt đầu, hai đội sẽ trả lời câu hỏi trong vòng 5 phút để dành sợi dây về phía mình, mỗi câu trả lời đúng được 10 điểm" },
      { step: 5, description: "Đội nào được nhiều điểm hơn sẽ giành chiến thắng" }
    ],
    benefits: [
      "Tăng cường sức mạnh toàn thân",
      "Phát triển tinh thần đoàn kết tập thể",
      "Rèn luyện ý chí kiên trì không bỏ cuộc",
      "Tạo không khí vui vẻ sôi động cho cả nhóm"
    ],
    notes: [],
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    relatedKnowledge: "Thi đấu thể thao truyền thống Bahnar",
    countdownSeconds: 3
  },
  {
    id: "thi-ca-kheo-len-doc",
    title: "Thi đi cà kheo lên dốc",
    shortDesc: "2 đội thi trả lời câu hỏi rồi đua cà kheo lên đỉnh dóc",
    description: "Thi đi cà kheo lên dốc là trò chơi truyền thống đầy kịch tính của người Bahnar, thường được tổ chức sôi nổi trong các dịp lễ hội buôn làng. Đây là trò chơi nhằm rèn luyện sự thăng bằng và sức mạnh đôi chân khi chinh phục địa hình dốc. Với dụng cụ đặc biệt là một cặp cà kheo tự chế từ hai cây le dài khoảng 2,5 đến 3 mét, có thanh ngang đặt chân được buộc chắc chắn ở độ cao từ 30 đến 80 cm tùy thuộc vào kỹ năng của người sử dụng.",
    image: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/6eaaa476fbad51db7e52d09823b9af72.png",
    chibiImage: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/4c8a583f74945e8e94e70aed2e5037c0.png",
    players: "2 đội",
    duration: "3-5 phút",
    category: "Đồng đội",
    rules: [
      "Mỗi đội có tối đa 5 lượt tham gia trả lời câu hỏi",
      "Trả lời sai thì cây cà kheo của đội đó sẽ dài thêm 1 đoạn",
      "Sau 5 lượt câu hỏi sẽ tiến hành thi đi cà kheo lên dóc",
      "Đội nào về đích trước là đội chiến thắng"
    ],
    howToPlay: [
      { step: 1, description: "Chia thành 2 đội: Đội 1 (Xanh) bên trái, Đội 2 (Đỏ) bên phải" },
      { step: 2, description: "Mỗi đội được phát một cây cà kheo có độ cao bằng nhau" },
      { step: 3, description: "Lần lượt mỗi đội trả lời 5 câu hỏi" },
      { step: 4, description: "Trả lời đúng: +10 điểm. Trả lời sai: cà kheo dài thêm 1 đoạn" },
      { step: 5, description: "Sau 5 vòng câu hỏi, tiến hành đua cà kheo. Đội nào về đích trước sẽ giành chiến thắng" }
    ],
    benefits: [
      "Kết hợp kiến thức văn hóa với vận động thể chất",
      "Phát triển tinh thần cạnh tranh lành mạnh",
      "Rèn luyện khả năng giữ thăng bằng trên cà kheo",
      "Tăng cường học hỏi về văn hóa Bahnar qua trò chơi"
    ],
    notes: [],
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    relatedKnowledge: "Lễ hội và phong tục Bahnar",
    countdownSeconds: 3
  },
  {
    id: "cheo-thuyen-doc-moc",
    title: "Chèo thuyền độc mộc",
    shortDesc: "Đua thuyền trên sông, thể hiện tinh thần đồng đội Bahnar",
    description: "Thuyền độc mộc là phương tiện di chuyển và lao động thiết yếu gắn liền với đời sống sinh hoạt ven các con sông Đak Bla và Pơkô của người Bahnar.",
    image: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/3220454fc41ca63ba9b229ef236e9914.png",
    chibiImage: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/8a9a922a9b2a719f16a0a313c4de07ea.png",
    tag: "Truyền thống",
    players: "4–12 người",
    duration: "3-5 phút",
    category: "Đồng đội",
    rules: [
      "Mỗi đội bắt đầu cuộc đua với một quỹ sinh mạng định mức gồm 5 \"trái tim\" hiển thị trên màn hình.",
      "Va chạm với vật cản vật lý (đá, gỗ) bị tính lỗi thao tác; va chạm rác thải sẽ kích hoạt câu hỏi trắc nghiệm.",
      "Người chơi bị tính thêm một lỗi nhận thức nếu chọn sai đáp án về các biểu hiện ô nhiễm môi trường.",
      "Quy tắc cộng dồn: cứ tích lũy đủ 3 lỗi (do va chạm hoặc trả lời sai) sẽ bị trừ mất 1 \"trái tim\".",
      "Đội chiến thắng là đội đưa thuyền về đích sớm nhất và vẫn bảo toàn được ít nhất một \"trái tim\" sinh mạng."
    ],
    howToPlay: [
      { step: 1, description: "Đua thuyền theo hành trình tuyến tính trên hai luồng sông song song với độ khó tăng dần qua 4 giai đoạn." },
      { step: 2, description: "Đội Xanh sử dụng phím A để qua trái và phím D để qua phải; Đội Đỏ sử dụng phím ◄ để qua trái và phím ► để qua phải." },
      { step: 3, description: "Người chơi cần tập trung quan sát để lướt thuyền né tránh các vật cản tĩnh và động xuất hiện ngẫu nhiên." },
      { step: 4, description: "Khi va chạm với rác thải, người chơi phải tương tác với hộp thoại và chọn đáp án đúng để tiếp tục hành trình." },
      { step: 5, description: "Các thành viên cần phối hợp nhịp nhàng để thuyền di chuyển đúng hướng và đạt tốc độ tối đa về đích." }
    ],
    benefits: [
      "Phát triển tinh thần đồng đội mạnh mẽ",
      "Rèn luyện sức mạnh cơ tay và vai",
      "Phát triển khả năng phối hợp nhịp điệu",
      "Tăng cường sức chịu đựng và ý chí"
    ],
    notes: [
      "Bắt buộc mặc áo phao khi chơi trên sông",
      "Phải có người lớn giám sát và đứng bờ hỗ trợ",
      "Chỉ chơi trên đoạn sông nước yên, không có dòng chảy mạnh",
      "Học bơi cơ bản trước khi tham gia trò chơi này"
    ],
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    relatedKnowledge: "Sông suối trong đời sống Bahnar",
    countdownSeconds: 5
  },
  {
    id: "thi-nuong-com-lam",
    title: "Thi nướng cơm lam",
    shortDesc: "Nướng cơm trong ống tre — trải nghiệm ẩm thực Bahnar",
    description: "Thi nướng cơm lam là một trò chơi dân gian thú vị của người Bahnar thường được tổ chức trong các dịp lễ hội nhằm giúp rèn luyện kỹ năng nội trợ và ý thức bảo tồn văn hóa ẩm thực địa phương.",
    image: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/26d184efed708f8e7e5a7b92d0ad16a8.png",
    chibiImage: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/4c8a583f74945e8e94e70aed2e5037c0.png",
    tag: "Lễ hội",
    players: "2–8 người",
    duration: "3-5 phút",
    category: "Cá nhân",
    rules: [
      "Người chơi phải thực hiện đầy đủ các bước chuẩn bị, vệ sinh và nấu cơm theo đúng thứ tự của trò chơi.",
      "Người chơi phải rửa tay, rửa dụng cụ và chọn thực phẩm sạch trước khi nấu, nếu làm sai phải làm lại.",
      "Các thao tác phải thực hiện đúng hướng dẫn như kéo thả, nhấn giữ, xoay, bấm nhiều lần mới hoàn thành nhiệm vụ.",
      "Những việc nguy hiểm như dùng dao và nhóm lửa phải nhờ người lớn hỗ trợ trong trò chơi.",
      "Kết quả được tính dựa trên việc thực hiện đúng quy trình, đảm bảo vệ sinh an toàn thực phẩm và cơm chín đều."
    ],
    howToPlay: [
      { step: 1, description: "Vòng 1: Người chơi chọn dụng cụ, chọn nguyên liệu sạch, rửa tay và rửa dụng cụ, rửa lá và ống nứa trước khi nấu." },
      { step: 2, description: "Vòng 2: Người chơi vo gạo, cho gạo và nước vào ống, bịt lá lên miệng ống và chuẩn bị nướng." },
      { step: 3, description: "Người chơi nhờ người lớn thực hiện các việc nguy hiểm như nhóm lửa và đặt ống lên bếp." },
      { step: 4, description: "Trong khi nướng, người chơi phải giữ lửa vừa và xoay ống cơm đều để cơm chín không bị cháy." },
      { step: 5, description: "Sau khi cơm chín, người chơi hoàn thành món ăn và làm bài kiểm tra nhỏ về an toàn thực phẩm để kết thúc trò chơi." }
    ],
    benefits: [
      "Giúp học sinh hiểu và ghi nhớ các bước vệ sinh an toàn thực phẩm.",
      "Rèn luyện tính cẩn thận, kiên nhẫn và làm việc theo quy trình.",
      "Giúp học sinh học thông qua trò chơi, tăng hứng thú và dễ tiếp thu kiến thức."
    ],
    notes: [
      "Đây là trò chơi mô phỏng, ngoài đời thật khi nấu ăn phải có người lớn hướng dẫn.",
      "Không tự ý sử dụng dao, lửa hoặc bếp khi không có người lớn.",
      "Luôn rửa tay, rửa dụng cụ và nấu chín thức ăn để đảm bảo an toàn thực phẩm."
    ],
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    relatedKnowledge: "Ẩm thực truyền thống người Bahnar",
    countdownSeconds: 4
  },
  {
    id: "kang",
    title: "K\'ăng",
    shortDesc: "Nhảy lò cò trên ô số — bản sắc riêng của Bahnar",
    description: "K\'ăng là trò chơi nhảy lò cò phổ biến của người Bahnar (Kon Tum) dành cho trẻ em từ 8 đến 15 tuổi. Trò chơi được thực hiện trên mặt sân đất vẽ hình chữ nhật chia thành 10 ô với dụng cụ là một viên sỏi hoặc mảnh ngói mài nhẵn. Không chỉ mang tính giải trí, K\'ăng còn giúp học sinh rèn luyện sự khéo léo, khả năng suy đoán và tính kiên nhẫn. Người thắng cuộc sẽ chiếm lĩnh ô số 5 và 6 – biểu tượng của \"nhà rông\" vinh quang.",
    image: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/5c90be97cc4f04b9b3b98e14a7be35a0.png",
    chibiImage: "https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/10dce3fc1ac2175331d2fac10eb08599.png",
    players: "2–8 người",
    duration: "3-5 phút",
    category: "Cá nhân",
    rules: [
      "Hai đội lần lượt bấm nút nhảy và thực hiện các nội dung ở ô đó",
      "Có 3 loại ô: May mắn, Thử thách, Câu hỏi. Nếu vào ô câu hỏi, trả lời đúng được 10 điểm, trả lời sai bị mất lượt.",
      "Đội nào về đích trước sẽ giành chiến thắng"
    ],
    howToPlay: [
      { step: 1, description: "Hai đội lần lượt bấm vào nút nhảy" },
      { step: 2, description: "Đến ô nào thì sẽ thực hiện nội dung ẩn chứa ở ô đó. Nếu trả lời đúng ở ô câu hỏi sẽ được 10 điểm. Thực hiện được ô thử thách sẽ được 5 điểm." },
      { step: 3, description: "Đội nào hoàn thành trước thì sẽ giành được chiến thắng" }
    ],
    benefits: [
      "Rèn luyện khả năng giữ thăng bằng trên một chân",
      "Phát triển kỹ năng đếm số cơ bản",
      "Tăng cường sự nhanh nhẹn và linh hoạt",
      "Chơi đơn giản không cần dụng cụ đặc biệt"
    ],
    notes: [],
    videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    relatedKnowledge: "Trò chơi vận động truyền thống Bahnar",
    countdownSeconds: 4
  }
];
